import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-thumbnail-video',
    templateUrl: './thumbnail-video.component.html',
    styleUrls: ['./thumbnail-video.component.css'],
})
export class ThumbnailVideoComponent implements OnInit {
    @Input() uploadTime = 1000
    @Input() forMobile = false
    converting = false

    constructor() {
    }

    ngOnInit() {
        setTimeout(() => {
            this.converting = true
        }, this.uploadTime)
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/thumbnail-video/thumbnail-video.component.ts